module.exports = __webpack_public_path__ + "img/cbr-cancel.53c6cdd9.svg";